import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import firebase from "../core/firebase";
import { AppError } from "../common/app-error";

export enum AUTHENTICATION_ERROR {
    WRONG_USERNAME = 'wrong_username',
    WRONG_PASSWORD = 'wrong_password',
    UNKNOWN = 'unknown'
}

class Authentication {

    static instance = new Authentication();
    private constructor() {
    }

    async login(email: string, password: string): Promise<boolean> {
        try {
            const userCredential = await signInWithEmailAndPassword(firebase.auth, email.trim(), password);
            return userCredential.user !== null;
        } catch(err: any) {
            if (err instanceof AppError) {
                throw err;
            }
            if (err?.code === "auth/invalid-credential" || err?.code === "auth/user-not-found") {
                throw new AppError(AUTHENTICATION_ERROR.WRONG_USERNAME);
            }
            if (err?.code === "auth/wrong-password") {
                throw new AppError(AUTHENTICATION_ERROR.WRONG_PASSWORD);
            }
            throw new AppError(AUTHENTICATION_ERROR.UNKNOWN, err?.code);
        }
    }

    async logout(): Promise<void> {
        await signOut(firebase.auth);
    }
}

export default Authentication.instance;